module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1052-4d047b4f02bb46554d9946aad482b9a3.png";